import Skeleton from '../../../../../../components/Skeleton';
import styles from './style.module.scss';

const PLACEHOLDER_CARDS = [0, 1, 2];

/** Mirrors the layout of `JobCard` while the posted jobs are being fetched. */
function JobsSkeleton() {
    return (
        <div role='status' aria-busy='true' aria-label='Loading jobs' className={styles.skeleton}>
            {PLACEHOLDER_CARDS.map(card => <div key={card} className={styles.skeleton_card}>
                <div className={styles.skeleton_card_head}>
                    <Skeleton width={42} height={42} radius={4} />
                    <div className={styles.skeleton_card_head_text}>
                        <Skeleton width={180} height={18} />
                        <Skeleton width={120} height={12} />
                    </div>
                </div>
                <Skeleton height={12} />
                <Skeleton width='70%' height={12} />
            </div>)}
        </div>
    );
};

export default JobsSkeleton;
